var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, useTheme, useMediaQuery, Fade } from "@mui/material";
/**
 * A simple page wrapper for consistency.
 * @param id element id
 * @param children page content
 * @param rest: Box Props
 * @returns
 */
export const AccountPageWrapper = (_a) => {
    var { id, children } = _a, rest = __rest(_a, ["id", "children"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    // const { cache } = useSWRConfig();
    // console.log("Cached data:", { page: id, cache });
    return (_jsx(Fade, Object.assign({ in: true, timeout: 300 }, { children: _jsx(Box, Object.assign({ id: id, width: "100%", flexGrow: 1 }, rest, { padding: isMobile ? 1 : 0 }, { children: children })) })));
};
